import { render, staticRenderFns } from "./IO.vue?vue&type=template&id=3f37bef6&scoped=true"
import script from "./IO.vue?vue&type=script&lang=js"
export * from "./IO.vue?vue&type=script&lang=js"
import style0 from "./IO.vue?vue&type=style&index=0&id=3f37bef6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f37bef6",
  null
  
)

export default component.exports